export default __webpack_public_path__ + "static/media/remote.215a11cf.webp";